import { useEffect } from 'react';
import { getAccessToken } from '@/shared/auth/jwt-storage';
import { loadCrmProfile } from '@/shared/auth/auth.reducer';
import { useAppDispatch, useAppSelector } from '@/store';
/**
 * Load `GET /api/users/profile` once per authenticated session (softphone, ACW pause fields, etc.).
 * Refetches on full page reload / bfcache restore so `isPhonePause` + `phonePauseEnd` restore ACW.
 */
export function useCrmProfile(enabled = true) {
    const dispatch = useAppDispatch();
    const session = useAppSelector((s) => s.auth.session);
    const crmProfile = useAppSelector((s) => s.auth.crmProfile);
    const loading = useAppSelector((s) => s.auth.crmProfileLoading);
    const loaded = useAppSelector((s) => s.auth.crmProfileLoaded);
    const hasToken = typeof window !== 'undefined' && Boolean(getAccessToken());
    const authenticated = Boolean(session || hasToken);
    useEffect(() => {
        if (!enabled || !authenticated || loaded || loading)
            return;
        void dispatch(loadCrmProfile());
    }, [dispatch, enabled, authenticated, loaded, loading]);
    /** Hard refresh / back-forward cache — pull fresh pause fields after the first profile load. */
    useEffect(() => {
        if (!enabled || !authenticated)
            return;
        const onPageShow = () => {
            if (!loaded || loading)
                return;
            void dispatch(loadCrmProfile());
        };
        window.addEventListener('pageshow', onPageShow);
        return () => window.removeEventListener('pageshow', onPageShow);
    }, [dispatch, enabled, authenticated, loaded, loading]);
    return { crmProfile, loading };
}
